export class DefaultMarket implements MarketInterface {
    get() {
        return {
            currency: 'SEK',
            currencySymbol: 'kr',
            taxPercentage: 0.25,
            isoCode: 'se-SE',
            countryCodeAlpha2: 'SE',
            countryCodeAlpha3: 'SWE',
        }
    }
}
